import { __decorate, __metadata } from "tslib";
import { inject, customAttribute } from 'aurelia-framework';
/**
 * The mdc-button-label attribute is required in order for the trailing icon to be styled appropriately.
 * @selector [mdc-button-label]
 */
var MdcButtonLabel = /** @class */ (function () {
    function MdcButtonLabel(root) {
        this.root = root;
    }
    MdcButtonLabel.prototype.attached = function () {
        this.root.classList.add('mdc-button__label');
    };
    MdcButtonLabel = __decorate([
        inject(Element),
        customAttribute('mdc-button-label'),
        __metadata("design:paramtypes", [HTMLElement])
    ], MdcButtonLabel);
    return MdcButtonLabel;
}());
export { MdcButtonLabel };
//# sourceMappingURL=mdc-button-label.js.map